import liff from '@line/liff';

const LIFF_ID = import.meta.env.VITE_LIFF_ID as string | undefined;
const MOCK_LINE_USER = import.meta.env.VITE_MOCK_LINE_USER as string | undefined;

export interface LineProfile {
  userId: string;
  displayName?: string;
  pictureUrl?: string;
  idToken: string; // raw idToken (mock prefix หรือ jwt จริง)
}

// dev-friendly: ถ้าไม่มี VITE_LIFF_ID หรือเปิด VITE_MOCK_LINE_USER → ใช้ mock idToken
function buildMockIdToken(): string {
  const uid = MOCK_LINE_USER ?? 'Udev001';
  const name = encodeURIComponent('ทดสอบ Dev');
  return `mock:lineUserId=${uid}&name=${name}`;
}

export async function initLiff(): Promise<LineProfile> {
  if (!LIFF_ID || MOCK_LINE_USER) {
    return {
      userId: MOCK_LINE_USER ?? 'Udev001',
      displayName: 'ทดสอบ Dev',
      idToken: buildMockIdToken(),
    };
  }

  await liff.init({ liffId: LIFF_ID });
  if (!liff.isLoggedIn()) {
    liff.login();
    // จะ redirect ออกไป — return promise ที่ไม่ resolve เพื่อหยุดต่อ
    await new Promise(() => undefined);
  }
  const profile = await liff.getProfile();
  const idToken = liff.getIDToken();
  if (!idToken) throw new Error('LIFF: ไม่ได้รับ idToken');
  return {
    userId: profile.userId,
    displayName: profile.displayName,
    pictureUrl: profile.pictureUrl,
    idToken,
  };
}

export function liffLogout() {
  try {
    if (LIFF_ID && liff.isLoggedIn()) liff.logout();
  } catch {
    // noop
  }
}
